var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.zoomUser.zoom_user_id)?_c('span',{staticClass:"text-danger pointer",on:{"click":_vm.unlinkZoomAccount}},[_vm._v(_vm._s(_vm.$t('unlink')))]):_c('a',{attrs:{"href":_vm.zoomIntegrationLink}},[_c('span',[_vm._v(_vm._s(_vm.$t('link')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }